module.exports = __webpack_public_path__ + "static/img/share_img3.5df8509e.png";